import {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../state";
import equals from "fast-deep-equal";
import {AdvertisementAction} from "../state/types";
import {StatusRequiredAction} from "../state/status";
import Style from "./style.module.scss";


export const Skippy =(props: { time: number, onClick?:()=>void, top: number, adPlayFunc?: ()=>void }) =>
{
    const [begin, setBegin] = useState(()=>0);
    const [current, setCurrent] = useState(0)
    const interval = useRef<ReturnType<typeof setInterval>>();

    const loadInterval = useRef<ReturnType<typeof setInterval>>();
    const [loadBegin, setLoadBegin] = useState(0);
    const [loadCurrent, setLoadCurrent] = useState(0);

    const advtime = useSelector((state:AppState)=> state.waitingTime.advwaitingtime/1000, equals);
    const dispatch = useDispatch();
    useEffect(()=>{
        return ()=> {
            if (interval.current)
                clearInterval(interval.current);
            if (loadInterval.current) {
                // eslint-disable-next-line
                clearInterval(loadInterval.current);
            }
        }
        // eslint-disable-next-line
    },[])

    useEffect(()=>{
        if (interval.current)
            clearInterval(interval.current);
        if (props.time === -1)
            return;
        if (!begin) {
            const newbegin = new Date().getTime()
            setBegin(newbegin);
            setCurrent(newbegin);
        }
        interval.current = setInterval(()=>{
            setCurrent(new Date().getTime());
        }, 250);
        // eslint-disable-next-line
    }, [props.time])

    useEffect(()=> {
        if (loadInterval.current)
            clearInterval(loadInterval.current);
        if (props.time !== -1) {
            return;
        }
        if (!loadBegin) {
            const newbegin = new Date().getTime();
            setLoadBegin(newbegin)
            setLoadCurrent(newbegin);
        }
        interval.current = setInterval(()=>{
            setLoadCurrent(new Date().getTime());
        }, 250);
        // eslint-disable-next-line
    }, [props.time]);

    const stopPlayer = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        if (props.onClick)
            props.onClick();
        dispatch<StatusRequiredAction>({
            type: "RequiredStatus",
            payload: "STOP"
        });
    };

    const continuePlayer = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        if (props.onClick)
            props.onClick();
        dispatch<AdvertisementAction>({
            type: "AdvertisementEnd"
        });
    }
    let canPlay = <></>;
    if (props.adPlayFunc) {
        const adPlayFunc = props.adPlayFunc;
        canPlay = <a href={'#pokracovat'} onClick={(e)=>{
            e.preventDefault();
            adPlayFunc();
        }}>Pokračovat</a>
    }

    return <div style={{
        top: props.top + 'px'
    }} className={Style.reklamaExternalInformace} >
        {(()=>{
            const seconds = Math.round((current - begin) / 1000);
            switch (true) {
                case props.time === -1: {
                    const seconds = Math.round((loadCurrent - loadBegin) / 1000);
                    if (seconds > advtime)
                        return <>Načítání reklamy <a href={'#stop'} onClick={stopPlayer}>Stop</a></>;
                    else
                        return <>Načítání reklamy {advtime - seconds}s <a href={'#stop'} onClick={stopPlayer}>Stop</a></>
                }
                case seconds < 10:
                    return <>Reklamu budete moci přeskočit za {10-seconds}s. {canPlay} <a href={'#stop'} onClick={stopPlayer}>Stop</a></>
                case props.time <= 10 && props.time > 1:
                    return <>Reklama skončí za za {Math.round(props.time) - seconds}s. {canPlay} </>
                default:
                    return <><a href={'#skip'} onClick={continuePlayer}>Přeskočit reklamu</a> {canPlay}</>
            }
        })()}
    </div>

}